import * as React from 'react';
import { Context } from '@grandvisionhq/carts-v2';
import { useIntl, useFeatureToggles, useSelector } from '@grandvisionhq/state';
import '@grandvisionhq/utils';
import { getSelectedPostalCode } from '../selectors.js';
import '@swc/helpers';
import 'lodash/isEmpty';
import '../../mappers/errors-mapping.js';
import '../../utils/get-customer-details-payload.js';
import '../../models/cart/cart-state.js';
import '../../models/checkout/checkout-step-error-type.js';
import '../../models/checkout-settings.js';
import '../../models/step-shipping/shipping-methods.js';
import '../../models/shared.js';
import 'history';
import '../../utils/has-cart-errors.js';
import '@grandvisionhq/payments';
import '@grandvisionhq/auth';
import '../../context/CheckoutSettings/context.js';
import '../../selectors.js';
import '@grandvisionhq/common';
import '@grandvisionhq/graphql';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/svc-tealium/events';
import '../../operations/mutations/set-customer-details.js';
import '../../operations/mutations/set-service-store.js';
import '../../operations/mutations/set-shipping-method.js';
import '../../operations/mutations/set-shipping-state.js';
import '../../operations/mutations/create-apple-pay-session.js';
import '../../operations/mutations/recreate-ordered-checkout.js';
import { useSetShippingMethodState } from '../../hooks/operations/use-set-shipping-method-state.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/fun-orders';
import '@grandvisionhq/analytics';
import '../../operations/fragments/checkout-mutation-result.js';
import '../../operations/fragments/cart-mutation-failures.js';
import '../../operations/fragments/recreate-ordered-checkout-failure.js';
import '../../operations/fragments/recreate-ordered-checkout-result.js';
import '../../operations/fragments/paypal-payment.js';
import '../../operations/fragments/saved-user-details.js';
import '../../operations/queries/get-checkout-state.js';
import '../../operations/queries/get-user-details.js';

const useUpdatedShippingMethods = ({ onNextStep , isServiceStoreUpdating  })=>{
    const { cart  } = Context.useCart();
    const { country  } = useIntl();
    const { allowAlternativeShippingState , featureConfigs  } = useFeatureToggles();
    const { alternativeShippingRegex  } = featureConfigs;
    const postalCode = useSelector(getSelectedPostalCode);
    const [shouldShowUpdatedShippingMethodsModal, setShouldShowUpdatedShippingMethodsModal] = React.useState(false);
    const { setShippingMethodState  } = useSetShippingMethodState();
    const resetShippingMethodsStateRef = React.useRef(false);
    const resetShippingMethodsState = React.useCallback(()=>{
        setShippingMethodState(country);
        resetShippingMethodsStateRef.current = true;
    }, [
        country,
        setShippingMethodState
    ]);
    // Reset the shipping state on the back-end to ensure all shipping methods are fetched, avoiding a restricted subset.
    React.useEffect(()=>{
        if (allowAlternativeShippingState && (cart === null || cart === void 0 ? void 0 : cart.id) && !isServiceStoreUpdating && !resetShippingMethodsStateRef.current) {
            resetShippingMethodsState();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cart === null || cart === void 0 ? void 0 : cart.id
    ]);
    const isShippingMethodStateValid = React.useCallback(()=>{
        if (!allowAlternativeShippingState) {
            return true;
        }
        return Boolean(postalCode && alternativeShippingRegex && !(alternativeShippingRegex === null || alternativeShippingRegex === void 0 ? void 0 : alternativeShippingRegex.test(postalCode)));
    }, [
        allowAlternativeShippingState,
        alternativeShippingRegex,
        postalCode
    ]);
    const handleSetShippingMethodStateCompleted = React.useCallback((cartId)=>{
        if (!cartId) {
            console.error('No cart ID provided after setting shipping method state');
            onNextStep();
        } else {
            setShouldShowUpdatedShippingMethodsModal(true);
        }
    }, [
        onNextStep
    ]);
    const { setShippingMethodState: setShippingMethodStateWithCallback  } = useSetShippingMethodState({
        onCompleted: handleSetShippingMethodStateCompleted
    });
    const handleUpdateShippingMethodsState = React.useCallback(()=>{
        postalCode && setShippingMethodStateWithCallback(country, postalCode);
    }, [
        country,
        postalCode,
        setShippingMethodStateWithCallback
    ]);
    return React.useMemo(()=>({
            handleUpdateShippingMethodsState,
            isShippingMethodStateValid,
            shouldShowUpdatedShippingMethodsModal,
            onCloseUpdatedShippingMethodsModal: ()=>setShouldShowUpdatedShippingMethodsModal(false)
        })
    , [
        handleUpdateShippingMethodsState,
        isShippingMethodStateValid,
        shouldShowUpdatedShippingMethodsModal, 
    ]);
};

export { useUpdatedShippingMethods };
//# sourceMappingURL=use-updated-shipping-methods.js.map
